<template>
  <settings-checker>
    <div class="booking">
      <div class="booking-wrapper">
        <petstar-ribbon/>
        <div class="booking-divider booking-divider-left">
          <div class="booking-content">
              <booking-header/>
              <div class="w-100 d-block d-md-none px-4 mb-3">
                <button class="btn btn-outline-secondary w-100" @click="tryLogout">
                  <i class="fas fa-sign-out-alt"></i> Logout
                </button>
              </div>
              <template v-if="[0,3,4].includes(tab)">
                <opening-hours v-if="availableResourceOpenSlots.length === 0 || tab === 4"/>
                <open-slot-list v-if="tab === 0 && availableResourceOpenSlots.length > 0" :slots="availableResourceOpenSlots" :resources="resources"/>
              </template>
              <template v-else>
                <div class="section-header d-flex">Booking Summary</div>
                <booking-summary/>
              </template>
          </div>
          <div class="fixed-buttons d-none d-md-block">
            <button class="btn btn-outline-secondary w-100" @click="tryLogout">
              <i class="fas fa-sign-out-alt"></i> Logout
            </button>
          </div>
        </div>
        <idle @idle="handleIdle"/>
        <site-booking-setting-set/>
        <appointment-defaults-set
          :service-based-duration-enabled="siteBookingSettingServiceBasedDurationEnabled"
          :service-select-enabled="siteBookingSettingServiceSelectEnabled"/>
        <pet-select v-if="tab === 0" @next="handleNext" @toLastPet="handleToLastPet"/>
        <products-select v-if="tab === 1" @next="handleNext" @back="handleBack" :last-pet="lastPet"/>
        <date-time-select v-if="tab === 2" @next="handleNext" @back="handleBack" @toLastPet="handleToLastPet" :resource-time-slots-enabled="siteBookingSettingResourceTimeSlotsEnabled"/>
        <client-address v-if="tab === 3" @next="handleNext" @back="handleBack"/>
        <booking-confirmation v-if="tab === 4" @back="handleBack"/>
      </div>
    </div>
  </settings-checker>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin'
import { ClientAddressCacheMixin } from '@/mixins/Booking/ClientAddressCacheMixin'
import { FormatCountryCacheMixin } from '@/mixins/Booking/FormatCountryCacheMixin'
import { ClientSetMixin } from '@/mixins/Booking/ClientSetMixin'
import { OpenSlotCacheMixin } from '@/mixins/Booking/OpenSlotCacheMixin'
import OpenSlotList from './OpenSlotList.vue'
import PetstarRibbon from './PetstarRibbon.vue'
import Header from './Header.vue'
import OpeningHours from './OpeningHours.vue'
import PetSelect from './PetSelect/PetSelect.vue'
import AppointmentDefaultsSet from './AppointmentDefaultsSet.vue'
import SiteBookingSettingSet from './SiteBookingSettingSet.vue'
import ProductsSelect from './ProductsSelect.vue'
import DateTimeSelect from './TimeSlots/DateTimeSelect.vue'
import SettingsChecker from './SettingsChecker.vue'
import Summary from './Summary.vue'
import Confirmation from './Confirmation.vue'
import Idle from './Idle.vue'
import ClientAddress from './Anonymous/ClientAddress.vue'

export default {
  name: 'BookingAuthenticated',
  mixins: [SiteBookingSettingMixin, ClientAddressCacheMixin, FormatCountryCacheMixin, ClientSetMixin, OpenSlotCacheMixin],
  data  () {
    return {
      tab: 0,
      lastPet: false
    }
  },
  computed: {
    clientAddressRequired () {
      return this.siteBookingSettingRegisteredClientAddressRequired && !this.clientAddress
    }
  },
  methods: {
    ...mapActions('Authentication', [
      'logout'
    ]),
    ...mapMutations('BookingUpload', [
      'resetBookingUpload'
    ]),
    handleNext () {
      if (!this.siteBookingSettingServiceSelectEnabled && this.tab === 0) { // pet-select: skip products
        if (this.openSlotBooking) { // also skip date-time
          this.applyOpenSlotData()
          this.tab = this.clientAddressRequired ? 3 : 4
        } else {
          this.tab = 2
        }
      } else if (this.openSlotBooking && this.tab === 1) { // products: skip date-time
        this.applyOpenSlotData()
        this.tab = this.clientAddressRequired ? 3 : 4
      } else if (!this.clientAddressRequired && this.tab === 2) { // date-time: skip address
        this.tab = 4
      } else {
        this.tab++
      }
    },
    handleBack () {
      if (this.openSlotBooking && this.tab === 3) { // address: skip date-time
        this.tab = this.siteBookingSettingServiceSelectEnabled ? 1 : 0
      } else if (this.openSlotBooking && !this.clientAddressRequired && this.tab === 4) { // confirm: skip date-time
        this.tab = this.siteBookingSettingServiceSelectEnabled ? 1 : 0
      } else if (!this.siteBookingSettingServiceSelectEnabled && this.tab === 2) { // date-time: skip products
        this.tab = 0
      } else if (!this.clientAddressRequired && this.tab === 4) { // confirm: skip address
        this.tab = 2
      } else {
        this.tab--
      }
    },
    handleToLastPet (value) {
      this.lastPet = !!value
    },
    tryLogout () {
      this.logout().then(() => {
        this.$router.push({ name: 'login', query: { siteId: this.selectedSiteId } })
          .then(() => { window.location.reload() })
      })
    },
    handleIdle () {
      this.tryLogout()
    }
  },
  created () {
    this.resetBookingUpload()
  },
  components: {
    'settings-checker': SettingsChecker,
    'petstar-ribbon': PetstarRibbon,
    'booking-header': Header,
    'opening-hours': OpeningHours,
    'open-slot-list': OpenSlotList,
    'booking-summary': Summary,
    'pet-select': PetSelect,
    'products-select': ProductsSelect,
    'date-time-select': DateTimeSelect,
    'booking-confirmation': Confirmation,
    'site-booking-setting-set': SiteBookingSettingSet,
    'appointment-defaults-set': AppointmentDefaultsSet,
    'client-address': ClientAddress,
    idle: Idle
  }
}
</script>
